<div>
    <template v-if="loading && showSkeleton">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </template>
    <template v-else>
        <div v-if="nextDate">
            <div class="mb-4">
                <h1>Delay time set</h1>
                <div class="mt-2">
                    Case title: {{ caseModel ? caseModel.title : "" }}
                </div>
            </div>

            Thank you for your feedback.
            <br />
            Please provide feedback until {{ nextDate }} CET.
            <br />
            <br />
            If you do not provide feedback until the chosen date, the case
            will be escalated.
        </div>
        <div v-else>
            <div class="mb-4">
                <h1>Set delay time for the case</h1>
                <div class="mt-2">
                    Case title: {{ caseModel ? caseModel.title : "" }}
                </div>
            </div>

            <v-form ref="form" @submit.prevent="submit">
                <div>
                    <label class="d-block mb-1">
                        Please enter the estimated delay (days) for this
                        case here:
                    </label>
                    <v-text-field
                        v-model="days"
                        label="Days"
                        type="number"
                        style="width: 200px"
                        :rules="[(v) => !!v || 'Days is required']"
                        variant="outlined"
                        :loading="loading"
                        clearable></v-text-field>
                </div>
                <div>
                    <label class="d-block mb-1">
                        Please provide us with the reason why the case needs
                        to be delayed for more than 5 working days:
                    </label>
                    <v-textarea
                        variant="outlined"
                        label="Reason"
                        :rules="[(v) => !!v || 'Reason is required']"
                        :loading="loading"
                        v-model="reason"></v-textarea>
                </div>
                <div class="d-flex justify-end">
                    <BaseButton
                        submit
                        :width="200"
                        :disabled="loading || disabled">
                        Confirm
                    </BaseButton>
                </div>
            </v-form>
        </div>
    </template>
</div>